import { uiRows } from './types-def.js';
/** `web/sheet-form` (1.AC-2): the stat-block form. */
export const SHEET_FORM_INTERACTIONS = uiRows([
    {
        id: 'sheets.form.paste-to-parse',
        module: 'web/sheet-form',
        behavior: 'Pasting a stat block into the form fills its fields, for review before saving',
        owner: '1.AC-2',
        since: 'exit-1b',
    },
    {
        id: 'sheets.form.compare-srd',
        module: 'web/sheet-form',
        behavior: "A variant's form compares its values with its SRD source, field by field",
        owner: '1.AC-2',
        since: 'exit-1b',
    },
]);
//# sourceMappingURL=sheet-form.js.map